import { isPlatformBrowser } from '@angular/common';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';

/** Adds X-Client-Source header [web|server] to every outgoing request from the app depending on the platform. */
export const xClientSourceInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const platformId = inject(PLATFORM_ID);
  const cloned = req.clone({
    setHeaders: {
      'X-Client-Source': isPlatformBrowser(platformId)
        ? 'web'
        : 'static_generator',
    },
  });
  return next(cloned);
};
